<template><svg id="Buddy" xmlns="http://www.w3.org/2000/svg" width="128" height="135" viewBox="0 0 128 135">
  <path fill="#155774"
        d="M68.12,67.5,80.5,55.12A2.91,2.91,0,0,0,76.38,51L64,63.38,51.62,51a2.91,2.91,0,0,0-4.12,4.12L59.88,67.5,47.5,79.88A2.91,2.91,0,0,0,51.62,84L64,71.62,76.38,84a2.91,2.91,0,0,0,4.12-4.12Z"/>
</svg>
</template>